<!-- SucursalIndex.vue -->
<template>
  <main role="main">
    <!-- Sección de breadcrumb -->
    <SucursalBreadcrumb></SucursalBreadcrumb>

    <!-- Sección de título principal -->
    <sucursal-titulo></sucursal-titulo>

    <!-- Sección de búsqueda -->
    <sucursal-buscar :data="data" @update:filteredOffices="filteredOffices = $event"
      @update:filteredOfficesRegion="filteredOfficesRegion = $event" @update:selectedLocation="updateSelectedLocation"
      :comunas="comunas" :selectedComuna="selectedComuna"></sucursal-buscar>

    <!-- Componente para mostrar resultados positivos -->
    <sucursal-respuesta v-if="hasOffices" :filteredOffices="filteredOffices"
      :filteredOfficesRegion="filteredOfficesRegion"></sucursal-respuesta>

    <!-- Componente para mostrar resultados negativos -->
    <sucursal-respuesta-negativa :hasOffices="hasOffices" :filteredOfficesRegion="filteredOfficesRegion"
      :filteredOffices="filteredOffices" :selectedComuna="selectedComuna"
      :comunas="comunas"></sucursal-respuesta-negativa>

    <sucursal-cercana v-if="showNearbyOffices" :filteredOfficesRegion="filteredOfficesRegion" :comunas="comunas"
      :selectedComuna="selectedComuna"></sucursal-cercana>

  </main>
</template>

<script>
import SucursalTitulo from './components/SucursalTitulo.vue'
import SucursalRespuestaNegativa from './components/SucursalRespuestaNegativa.vue'
import SucursalBuscar from './components/SucursalBuscar.vue'
import SucursalRespuesta from './components/SucursalRespuesta.vue'
import SucursalCercana from './components/SucursalCercana.vue'
import SucursalBreadcrumb from './components/SucursalBreadcrumb.vue'

export default {
  components: {
    SucursalTitulo,
    SucursalBreadcrumb,
    SucursalBuscar,
    SucursalRespuesta,
    SucursalRespuestaNegativa,
    SucursalCercana
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filteredOffices: [],
      filteredOfficesRegion: [],
      selectedRegion: "",
      selectedComuna: "",
      comunas: [],
    }
  },
  methods: {
    updateSelectedLocation({ region, comuna }) {
      this.selectedRegion = region;
      this.selectedComuna = comuna;
    },
    initializeComunas() {
      // Filtrar y crear lista de comunas
      this.comunas = _.chain(this.data.location)
        .filter(item => item.type === 'comuna')
        .map(comuna => ({
          regionValue: comuna.parent_id,
          value: comuna.id,
          name: comuna.name,
          lat: comuna.lat,
          lng: comuna.lng,
        }))
        .value();
    },
  },
  computed: {
    hasOffices() {
      if (this.selectedComuna && this.selectedRegion) {
        // Solo retorna true si hay al menos una oficina regular (no municipal)
        return this.filteredOffices.some(office => !office.is_municipal);
      }
      return true;
    },
    showNearbyOffices() {
      // Mostrar solo cuando:
      // 1. No hay oficinas regulares (solo municipales o ninguna)
      // 2. Y hay comuna y región seleccionada
      return this.selectedComuna &&
        this.selectedRegion &&
        !this.filteredOffices.some(office => !office.is_municipal);
    }
  },
  mounted() {
    this.initializeComunas();
  }
}
</script>